/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum hazmat_placarding_status {
  PLACARDED = 'placarded',
  CONDITIONAL = 'conditional',
  NON_PLACARDED = 'non_placarded',
}
